import { useLingui } from '@lingui/react/macro';
import { useRouteContext } from '@tanstack/react-router';
import { cn } from '@worldcoo/ui/lib/utils';
import { openUsercentricsPrivacySettings } from '@worldcoo/ui/lib/usercentrics';

/** Shared by the four footers. A `<button>`, not the CMP docs' `<a href="#">`: it opens a dialog, not a page. */
export function PrivacySettingsLink(props: { className?: string }) {
	const { isInIframe } = useRouteContext({ from: '__root__' });
	const { t } = useLingui();

	// An embed never loads the CMP, and consent there belongs to the host. The `iframe` param alone misses
	// cross-site embeds the server infers from `Sec-Fetch-*`.
	if (isInIframe) return null;

	return (
		<button type="button" onClick={openUsercentricsPrivacySettings} className={cn('cursor-pointer', props.className)}>
			{t`Privacy Settings`}
		</button>
	);
}
